<script lang="ts" setup>
	defineOptions({ inheritAttrs: false })
	const attrs = useAttrs()
	const configClass = {
		margin: 'mx-auto',
		paddingInline: 'xs:px-5 md:px-10 px-3',
		paddingBlock: 'xs:py-10 py-5',
		width: 'max-w-[1240px]  xl:max-w-[1500px] mx-auto'
	}
	withDefaults(
		defineProps<{
			ui?: {
				margin?: string
				paddingInline?: string
				paddingBlock?: string
				width?: string
			}
			tag?: string
		}>(),
		{
			tag: 'section'
		}
	)
	</script>
<template>
	<ui-wrapper
		v-bind="attrs"
		:tag="tag"
		:class="[
			ui?.margin ?? configClass.margin,
			ui?.paddingBlock ?? configClass.paddingBlock,
			ui?.paddingInline ?? configClass.paddingInline,
			ui?.width ?? configClass.width
		]"
	>
		<slot />
	</ui-wrapper>
</template>
